import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment, renderList as _renderList, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-85c2db22"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "content_top fixed" }
const _hoisted_3 = { class: "modal_title space-between" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "보유주식 팔기", -1))
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "search_box" }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "search_box" }
const _hoisted_9 = ["disabled"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "desc" }, " 회사이름을 직접입력하여 등록합니다. ", -1))
const _hoisted_11 = {
  key: 0,
  class: "stocks-list"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input-direct" }, " 직접입력 > ", -1))
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = { id: "stocks-list" }
const _hoisted_15 = { class: "vote_top cursor" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { class: "small_logo" }
const _hoisted_18 = ["src"]
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "inset-border" }, null, -1))
const _hoisted_20 = { class: "d inline" }
const _hoisted_21 = { class: "company_title" }
const _hoisted_22 = { class: "sub_info" }
const _hoisted_23 = ["disabled", "onClick"]
const _hoisted_24 = {
  key: 0,
  class: "starToggle",
  src: "/assets/icon/star_b.png"
}
const _hoisted_25 = {
  key: 1,
  class: "starToggle",
  src: "/assets/icon/star_g.png"
}
const _hoisted_26 = { class: "content_top" }
const _hoisted_27 = { class: "stock-item-name" }
const _hoisted_28 = { class: "small_logo" }
const _hoisted_29 = ["src"]
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "inset-border" }, null, -1))
const _hoisted_31 = { class: "item-name" }
const _hoisted_32 = { class: "sell-info" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ion-float-left" }, " 희망 가격 ", -1))
const _hoisted_34 = { class: "bold" }
const _hoisted_35 = { class: "" }
const _hoisted_36 = { class: "sell-info" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ion-float-left" }, " 희망 수량 ", -1))
const _hoisted_38 = { class: "bold" }
const _hoisted_39 = { class: "light" }
const _hoisted_40 = { class: "sell-info" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ion-float-left" }, " 판매 가능 최소량 ", -1))
const _hoisted_42 = { class: "bold" }
const _hoisted_43 = { class: "light" }
const _hoisted_44 = { class: "sell-info" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ion-float-left" }, " 증명서류 ", -1))
const _hoisted_46 = { class: "ion-float-right fill" }
const _hoisted_47 = {
  key: 0,
  class: ""
}
const _hoisted_48 = { class: "content-middle" }
const _hoisted_49 = { class: "title" }
const _hoisted_50 = { class: "value" }
const _hoisted_51 = { class: "num" }
const _hoisted_52 = { class: "unit" }
const _hoisted_53 = { class: "description" }
const _hoisted_54 = { class: "content-middle" }
const _hoisted_55 = { class: "file-area" }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "주권미발행확인서, 주주명부, MTS 화면캡쳐"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 등의 증명서류를 첨부해주세요 ")
], -1))
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "blue" }, [
  /*#__PURE__*/_createTextVNode(" 판매자 본인의 주식 보유 확인 용도이며,"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 노출되지 않습니다 ")
], -1))
const _hoisted_58 = { class: "select-file" }
const _hoisted_59 = { class: "bottom" }
const _hoisted_60 = { class: "pad-container" }
const _hoisted_61 = ["onClick"]
const _hoisted_62 = { class: "row" }
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "clear" }, "00", -1))
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "0", -1))
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  alt: "backspace",
  class: "backSpace",
  src: "/assets/icon/backspace@3x.png"
}, null, -1))
const _hoisted_66 = { class: "content_bottom" }
const _hoisted_67 = { class: "check-container list_15M" }
const _hoisted_68 = { key: 0 }
const _hoisted_69 = { key: 1 }
const _hoisted_70 = /*#__PURE__*/_createTextVNode(" 이전 ")
const _hoisted_71 = ["disabled"]
const _hoisted_72 = /*#__PURE__*/_createTextVNode(" 다음 ")
const _hoisted_73 = ["disabled"]
const _hoisted_74 = /*#__PURE__*/_createTextVNode(" 이 조건으로 팔기 ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_searchbar = _resolveComponent("ion-searchbar")!
  const _component_ion_input = _resolveComponent("ion-input")!
  const _component_ion_ripple_effect = _resolveComponent("ion-ripple-effect")!
  const _component_ion_checkbox = _resolveComponent("ion-checkbox")!
  const _component_ion_content = _resolveComponent("ion-content")!

  return (_openBlock(), _createBlock(_component_ion_content, { "overflow-scroll": "false" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("span", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen,'clickArea':'헤더', 'clickContent':`닫기`});_ctx.dismiss()})
            }, "닫기")
          ]),
          (_ctx.checkProcessStatus(1))
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                (!_ctx.keyInitemNameDriectly)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      _createElementVNode("div", _hoisted_6, [
                        _createVNode(_component_ion_searchbar, {
                          placeholder: "회사명, 종목(주식)코드 검색",
                          debounce: "500",
                          onIonChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.searchKeyword($event))),
                          onIonClear: _cache[2] || (_cache[2] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'검색영역', 'clickContent':'취소버튼'});_ctx.searchCleared($event)})
                        })
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, [
                        _createVNode(_component_ion_input, {
                          type: "text",
                          onIonChange: _cache[3] || (_cache[3] = ($event) => _ctx.sellInfo.stockItemName = $event.detail.value)
                        }),
                        _withDirectives(_createElementVNode("button", {
                          class: "inline_btn",
                          disabled: !_ctx.buttonEnable(),
                          onClick: _cache[4] || (_cache[4] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'회사명 직접입력', 'clickContent':'다음'});_ctx.setProcessStatus('next')})
                        }, " 다음 ", 8, _hoisted_9), [
                          [_vShow, _ctx.checkProcessStatus(1)]
                        ])
                      ]),
                      _hoisted_10
                    ]))
              ], 64))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", {
          class: _normalizeClass([{'fit-margin':_ctx.checkProcessStatus(2,3,4,5)}, "modal_content"])
        }, [
          (!_ctx.keyInitemNameDriectly)
            ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_11, [
                _withDirectives(_createElementVNode("div", {
                  class: "stock_info",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'검색결과', 'clickContent':'직졉입력'});_ctx.requestItem()})
                }, _hoisted_13, 512), [
                  [_vShow, _ctx.companyInput]
                ]),
                _createElementVNode("div", _hoisted_14, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.searchStockItems, (stock) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: stock.stockItemId,
                      class: "vote_company main-deal"
                    }, [
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("div", {
                          class: "ion-activatable ripple-parent vote_top_left",
                          onClick: ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'검색결과', 'clickContent':`${stock.stockItemName}`});_ctx.setCompany(stock)}
                        }, [
                          _createElementVNode("div", _hoisted_17, [
                            _createElementVNode("img", {
                              src: stock.companyLogo ? stock.companyLogo : '/assets/icon/company_default_img.png',
                              onerror: "this.src='/assets/icon/company_default_img.png'",
                              class: "img-responsive img-circle"
                            }, null, 8, _hoisted_18),
                            _hoisted_19
                          ]),
                          _createElementVNode("div", _hoisted_20, [
                            _createElementVNode("div", _hoisted_21, _toDisplayString(stock.stockItemName), 1),
                            _createElementVNode("div", _hoisted_22, _toDisplayString(stock.codeNumber), 1)
                          ]),
                          _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
                        ], 8, _hoisted_16),
                        _createElementVNode("button", {
                          class: "ion-activatable ripple-parent vote_top_right",
                          disabled: ~['mna','ipo'].indexOf(stock.companyStatus),
                          onClick: ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'검색결과', 'clickContent':`관심버튼`});(_ctx.user === null ? _ctx.$global.openLoginModal() :_ctx.itemLikeCompany(stock.stockItemId))}
                        }, [
                          (stock.likeFlag)
                            ? (_openBlock(), _createElementBlock("img", _hoisted_24))
                            : (_openBlock(), _createElementBlock("img", _hoisted_25)),
                          _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
                        ], 8, _hoisted_23)
                      ])
                    ]))
                  }), 128))
                ])
              ], 512)), [
                [_vShow, _ctx.checkProcessStatus(1)]
              ])
            : _createCommentVNode("", true),
          _withDirectives(_createElementVNode("div", _hoisted_26, [
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("img", {
                  src: _ctx.sellInfo.companyLogo ? _ctx.sellInfo.companyLogo : '/assets/icon/company_default_img.png',
                  onerror: "this.src='/assets/icon/company_default_img.png'",
                  class: "img-responsive img-circle"
                }, null, 8, _hoisted_29),
                _hoisted_30
              ]),
              _createElementVNode("div", _hoisted_31, _toDisplayString(_ctx.sellInfo.stockItemName), 1)
            ]),
            _createElementVNode("div", _hoisted_32, [
              _hoisted_33,
              _createElementVNode("div", {
                class: _normalizeClass([{fill:(!!_ctx.sellInfo.sellPrice)}, "ion-float-right"])
              }, [
                _createElementVNode("span", _hoisted_34, _toDisplayString(_ctx.$filters.currency( _ctx.sellInfo.sellPrice ) || '-') + " 원", 1),
                _createElementVNode("span", _hoisted_35, _toDisplayString(_ctx.sellInfo.sellPriceNegoFlag === true ? ' · 협의가능' : ' · 협의불가능'), 1)
              ], 2)
            ]),
            _createElementVNode("div", _hoisted_36, [
              _hoisted_37,
              _createElementVNode("div", {
                class: _normalizeClass([{fill:(!!_ctx.sellInfo.qty)}, "ion-float-right"])
              }, [
                _createElementVNode("span", _hoisted_38, _toDisplayString(_ctx.$filters.currency( _ctx.sellInfo.qty ) || '-') + " 주", 1),
                _createElementVNode("span", _hoisted_39, _toDisplayString(_ctx.sellInfo.qty
                  ? ` (총 ${ _ctx.$filters.currency( _ctx.sellInfo.sellPrice * _ctx.sellInfo.qty ) }원)`
                  : ''), 1)
              ], 2)
            ]),
            _createElementVNode("div", _hoisted_40, [
              _hoisted_41,
              _createElementVNode("div", {
                class: _normalizeClass([{fill:(!!_ctx.sellInfo.sellMinQty)}, "ion-float-right"])
              }, [
                _createElementVNode("span", _hoisted_42, _toDisplayString(_ctx.$filters.currency( _ctx.sellInfo.sellMinQty ) || '-') + " 주", 1),
                _createElementVNode("span", _hoisted_43, _toDisplayString(_ctx.sellInfo.sellMinQty ? ` (총 ${ _ctx.$filters.currency( _ctx.sellInfo.sellPrice * _ctx.sellInfo.sellMinQty ) }원)` : ''), 1)
              ], 2)
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_44, [
              _hoisted_45,
              _createElementVNode("div", _hoisted_46, [
                (_ctx.sellInfo.files)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_47, _toDisplayString(_ctx.sellInfo.files ? ` ${ _ctx.printFileNameMaxlength( _ctx.sellInfo.files.name, 25 ) }` : ''), 1))
                  : (_openBlock(), _createElementBlock("a", {
                      key: 1,
                      onClick: _cache[6] || (_cache[6] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'증명서류', 'clickContent':`파일명`});_ctx.openMyFile(_ctx.sellInfo.filePath)})
                    }, _toDisplayString(_ctx.printFileNameMaxlength( _ctx.sellInfo.originFileName, 25 )), 1))
              ])
            ], 512), [
              [_vShow, _ctx.checkProcessStatus(5)]
            ])
          ], 512), [
            [_vShow, _ctx.checkProcessStatus(2,3,4,5)]
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_48, [
            _createElementVNode("div", _hoisted_49, _toDisplayString(_ctx.setMiddleContents.title), 1),
            _createElementVNode("div", _hoisted_50, [
              _createElementVNode("span", _hoisted_51, _toDisplayString(_ctx.setMiddleContents.num), 1),
              _createElementVNode("span", _hoisted_52, _toDisplayString(_ctx.setMiddleContents.unit), 1)
            ]),
            _createElementVNode("div", _hoisted_53, _toDisplayString(_ctx.setMiddleContents.description), 1)
          ], 512), [
            [_vShow, _ctx.checkProcessStatus(2,3,4)]
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_54, [
            _createElementVNode("div", _hoisted_55, [
              _hoisted_56,
              _hoisted_57,
              _createElementVNode("div", _hoisted_58, [
                _createElementVNode("div", {
                  class: "browse",
                  onClick: _cache[7] || (_cache[7] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'증명서류 첨부', 'clickContent':`파일 선택`});_ctx.openFileSelector()})
                }, " 파일 선택 "),
                _createElementVNode("input", {
                  id: "file_for_proof",
                  class: "file",
                  name: "file",
                  type: "file",
                  onChange: _cache[8] || (_cache[8] = ($event: any) => (_ctx.uploadFile($event)))
                }, null, 32)
              ])
            ])
          ], 512), [
            [_vShow, _ctx.checkProcessStatus(5)]
          ]),
          _createElementVNode("div", _hoisted_59, [
            _withDirectives(_createElementVNode("div", _hoisted_60, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList([0,1,2], (row) => {
                return _createElementVNode("div", {
                  key: row,
                  class: "row"
                }, [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (col) => {
                    return _createElementVNode("div", {
                      key: col,
                      class: "ion-activatable ripple-parent letter",
                      onClick: ($event: any) => (_ctx.addNumber(row * 3 + col, _ctx.curStatus))
                    }, [
                      _createElementVNode("span", null, _toDisplayString(row * 3 + col), 1),
                      _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
                    ], 8, _hoisted_61)
                  }), 64))
                ])
              }), 64)),
              _createElementVNode("div", _hoisted_62, [
                _createElementVNode("div", {
                  class: "ion-activatable ripple-parent letter",
                  onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.addNumber('00', _ctx.curStatus)))
                }, [
                  _hoisted_63,
                  _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
                ]),
                _createElementVNode("div", {
                  class: "ion-activatable ripple-parent letter",
                  onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.addNumber(0, _ctx.curStatus)))
                }, [
                  _hoisted_64,
                  _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
                ]),
                _createElementVNode("div", {
                  class: "ion-activatable ripple-parent letter",
                  onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.clearNumber('del', _ctx.curStatus)))
                }, [
                  _hoisted_65,
                  _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
                ])
              ])
            ], 512), [
              [_vShow, _ctx.checkProcessStatus(2,3,4)]
            ]),
            _createElementVNode("div", _hoisted_66, [
              _withDirectives(_createElementVNode("div", {
                class: _normalizeClass({disabled:!_ctx.buttonEnable()})
              }, [
                _createElementVNode("label", _hoisted_67, [
                  _createVNode(_component_ion_checkbox, {
                    slot: "end",
                    mode: "ios",
                    class: "checkmark",
                    "model-value": _ctx.sellInfo.sellPriceNegoFlag,
                    onClick: _cache[12] || (_cache[12] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'희망가격 입력', 'clickContent':`${_ctx.sellInfo.sellPriceNegoFlag?'가격협의가능':'가격협의불가능'}`});}),
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.sellInfo.sellPriceNegoFlag = $event))
                  }, null, 8, ["model-value"]),
                  (_ctx.sellInfo.sellPriceNegoFlag)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_68, "가격협의가능"))
                    : (_openBlock(), _createElementBlock("span", _hoisted_69, "가격협의불가능"))
                ])
              ], 2), [
                [_vShow, _ctx.checkProcessStatus(2)]
              ]),
              _withDirectives(_createElementVNode("button", {
                class: "ion-activatable ripple-parent previous_btn",
                onClick: _cache[14] || (_cache[14] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'하단버튼', 'clickContent':`이전`});_ctx.setProcessStatus('previous')})
              }, [
                _hoisted_70,
                _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
              ], 512), [
                [_vShow, !_ctx.checkProcessStatus(1)&&!_ctx.checkProcessStatus(2)]
              ]),
              _withDirectives(_createElementVNode("button", {
                disabled: !_ctx.buttonEnable(),
                class: "ion-activatable ripple-parent next_btn",
                onClick: _cache[15] || (_cache[15] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'하단버튼', 'clickContent':`다음`});_ctx.setProcessStatus('next')})
              }, [
                _hoisted_72,
                _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
              ], 8, _hoisted_71), [
                [_vShow, !_ctx.checkProcessStatus(1,5)]
              ]),
              _withDirectives(_createElementVNode("button", {
                disabled: !_ctx.buttonEnable(),
                class: "ion-activatable ripple-parent next_btn",
                onClick: _cache[16] || (_cache[16] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'하단버튼', 'clickContent':`이 조건으로 팔기`});_ctx.sendPost()})
              }, [
                _hoisted_74,
                _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
              ], 8, _hoisted_73), [
                [_vShow, _ctx.checkProcessStatus(5)]
              ])
            ])
          ])
        ], 2)
      ])
    ]),
    _: 1
  }))
}